var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { SpacesApi } from './apis/spaces-api.interface';
import _ from 'lodash';
let UserAvatarRepositoryImpl = class UserAvatarRepositoryImpl {
    constructor(_spaceApi) {
        this._spaceApi = _spaceApi;
    }
    async getAvatarByIds(userIds) {
        return this._spaceApi.getAvatarInfo(userIds).then((res) => {
            return _.mapValues(res, (item) => {
                return {
                    userId: item.user_id,
                    avatar: item.avatar,
                    avatarColor: _.toNumber(item.avatar_color).toString(16),
                    avatarPattern: item.avatar_pattern,
                    avatarValue: item.avatar_value,
                };
            });
        });
    }
};
UserAvatarRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(SpacesApi)),
    __metadata("design:paramtypes", [typeof (_a = typeof SpacesApi !== "undefined" && SpacesApi) === "function" ? _a : Object])
], UserAvatarRepositoryImpl);
export { UserAvatarRepositoryImpl };
